import { Col, Row } from 'antd';
import { PrimaryButton, SecondaryButton } from 'components/common/button';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import ROUTES from 'utils/constants/routes.json';

const StyledLink = styled(Link)`
    button {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
`;

const ResultTab = () => {
    const { pathname } = useLocation();

    const { t } = useTranslation('examinationDetails');

    return (
        <StyledLink style={{ width: '100%', margin: '24px 0' }} to={ROUTES.screening}>
            {pathname === ROUTES.screening ? (
                <PrimaryButton>{t('mammography_screening')}</PrimaryButton>
            ) : (
                <SecondaryButton>{t('mammography_screening')}</SecondaryButton>
            )}
        </StyledLink>
    );
};

export default ResultTab;
